import PropTypes from 'prop-types';
import React from 'react';

import StageRunSampleLink from 'workflows/components/StageRunSampleLink';
import {
  STAGE_RUN_FULL_SHAPE,
  STAGE_RUN_SAMPLE_FULL_SHAPE,
  StageRun,
  StageRunSample,
} from 'workflows/WorkflowConstants';

import InputTableContainerCell from './InputTableContainerCell';
import SharedInputTableRow from './SharedInputTableRow';

interface ParentSampleInputTableRowProps {
  checkboxCell: JSX.Element;
  experimentalConditionValueNames: Array<string>;
  inputSampleId: string;
  stageRun: StageRun;
  stageRunSampleById: {[stageRunSampleId: string]: StageRunSample};
  locked: boolean;
  viewer?: boolean;
}

/**
 * Input table row displaying a sample obtained from some parent.
 * There is a delete button that allows removing the row/sample.
 */
class ParentSampleInputTableRow extends React.Component<ParentSampleInputTableRowProps> {
  static propTypes = {
    checkboxCell: PropTypes.node.isRequired,
    experimentalConditionValueNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    inputSampleId: PropTypes.string.isRequired,
    stageRun: STAGE_RUN_FULL_SHAPE.isRequired,
    stageRunSampleById: PropTypes.objectOf(STAGE_RUN_SAMPLE_FULL_SHAPE).isRequired,
    locked: PropTypes.bool.isRequired,
    viewer: PropTypes.bool,
  };

  _renderSampleCell(): JSX.Element {
    return <StageRunSampleLink sample={this.props.stageRunSampleById[this.props.inputSampleId]} />;
  }

  _renderContainerCell(): JSX.Element {
    return (
      <InputTableContainerCell
        stageRun={this.props.stageRun}
        inputSampleId={this.props.inputSampleId}
        stageRunSampleById={this.props.stageRunSampleById}
        locked={this.props.locked}
        viewer={this.props.viewer}
      />
    );
  }

  render(): JSX.Element {
    return (
      <SharedInputTableRow
        checkboxCell={this.props.checkboxCell}
        experimentalConditionValueNames={this.props.experimentalConditionValueNames}
        sampleCellContents={this._renderSampleCell()}
        containerCellFullElement={this._renderContainerCell()}
        stageRun={this.props.stageRun}
      />
    );
  }
}

export default ParentSampleInputTableRow;
